import errorState from '../../../assets/error-state.svg';
import customerGroup from '../../../assets/platforms/sparklayer/customer-group-empty-state.svg';
import discount from '../../../assets/platforms/sparklayer/discounts-empty-state.svg';
import orders from '../../../assets/platforms/sparklayer/orders-empty-state.svg';
import priceList from '../../../assets/platforms/sparklayer/price-lists-empty-state.svg';
import salesAgent from '../../../assets/platforms/sparklayer/sales-agents-empty-state.svg';
import settingsAPI from '../../../assets/platforms/sparklayer/settings-api-empty-state.svg';
import shippingMethod from '../../../assets/platforms/sparklayer/shipping-empty-state.svg';
import themes from '../../../assets/platforms/sparklayer/themes-empty-state.svg';
import { cn } from '../../../lib/styles';
import { Heading } from '../heading/heading.spark';
import { Text } from '../text/text.spark';
import type { EmptyStateProps, ImageType } from './types';

const IMG_SOURCE: Record<ImageType, string> = {
  customerGroup,
  discount,
  priceList,
  orders,
  shippingMethod,
  errorState,
  salesAgent,
  settingsAPI,
  themes,
};

export function EmptyState(props: EmptyStateProps) {
  return (
    <div
      className={cn(
        'mx-auto flex max-w-md flex-col items-center gap-4',
        props.compact ? 'py-6' : 'py-12',
      )}
    >
      {props.imageType && <img className="size-48" src={IMG_SOURCE[props.imageType]} alt="" />}
      <div className="flex w-full flex-col items-center gap-1">
        <Heading level="h2" style="md">
          {props.title}
        </Heading>
        {props.subtitle && (
          <span className="text-center">
            <Text variant="secondary">{props.subtitle}</Text>
          </span>
        )}
        <div className="mt-1 flex w-full flex-col items-center">{props.children}</div>
      </div>
    </div>
  );
}
